import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { Client } from '@savgroup-front-common/types/Billing/Client';

export const ENDPOINT = `${APIConfiguration.owner}clients`;

interface GetClientsdQueryArgs {
  tenantId: string;
  term?: string;
  page?: number;
  pageSize?: number;
  orderColumn?:
    | 'None'
    | 'Name'
    | 'Email'
    | 'CustomerType'
    | 'PaymentType'
    | 'BillingMode'
    | 'PaymentTermDays'
    | 'PreferredLanguage';
}

const getClientsdQuery = async ({
  tenantId,
  term,
  orderColumn = 'None',
  page,
  pageSize,
}: GetClientsdQueryArgs): Promise<
  BackResponse<Client[]> | BackResponseFailure
> => {
  try {
    const url = buildUrl(ENDPOINT, {
      tenantId,
      term,
      orderColumn,
      page,
      pageSize,
    });

    const response = await apiCall<BackResponse<Client[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getClientsdQuery;
